import { faEnvelope } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import TextInput from '../../../App/Components/Form/TextInput/TextInput'
import { Box } from '../../../Common/Box'
import { IUserHr } from '../../../User/UsersHr/interfaces/IUserHr'

import { PersonEditText } from './style'

type Props = {
  personObject: IUserHr
  setPersonObject: (person: IUserHr) => void
  setEmailFeedback: (feedback: { error: string; warning: string }) => void
}

const EmailIcon = styled(FontAwesomeIcon)`
  color: #7e7e7e;
  margin-top: 4px;
  margin-right: 6px;
`

export const EmailEditInput: React.FC<Props> = ({
  personObject,
  setPersonObject,
  setEmailFeedback,
}) => {
  const { t } = useTranslation()

  const validateEmail = (email: string) => {
    setPersonObject({ ...personObject, email })

    if (email === '') {
      setEmailFeedback({ error: '', warning: '' })
      return false
    }

    const validDomains = [
      'gmail.com',
      'outlook.com',
      'icloud.com',
      'yahoo.com',
      'msn.com',
    ]

    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

    if (!emailRegex.test(email)) {
      setEmailFeedback({ error: `${t('Invalid email format')}`, warning: '' })
      return false
    }

    const emailDomain = email.split('@')[1]

    if (!validDomains.includes(emailDomain)) {
      for (const domain of validDomains) {
        if (domain.startsWith(emailDomain)) {
          setEmailFeedback({
            error: '',
            warning: `${t('Did you mean')} @${domain}?`,
          })
          return true
        }
      }
    }
    setEmailFeedback({ error: '', warning: '' })
    return true
  }

  return (
    <Box mt={2} mb={2}>
      <Box display={'flex'}>
        <EmailIcon icon={faEnvelope} />
        <PersonEditText> {t('Email')}</PersonEditText>
      </Box>
      <TextInput
        value={personObject.email}
        onChange={e => validateEmail(e.currentTarget.value)}
      />
    </Box>
  )
}
